import { Div } from "../../../../../base/components/native/div"
import { Input } from "../../../../../base/components/native/input"
import services from "../../../../../services"
import { TArticle } from "../../../../../types/article"
import { DeleteButton } from "../../../../shared/delete-button"
import { submitButton } from "../../shared/submit-button"
import { editorStyle, gridStyle, submitStyle } from "./articles.style"
import { ArticlesList } from "./articles-list"
import { TagsInput } from "./tags-input"
import { TitleInput } from "./title-input"
import { UrlInput } from "./url-input"

import { Tab } from "../tab"


export const ArticlesTab = () => {
    const base = Tab('articles')

    const grid = Div()
    grid.cssClass(gridStyle)
    base.append(grid)

    const list = ArticlesList()
    list.on('select', (article: TArticle) => {
        url.setValue('https://daneshfx.com/fa/articles/' + article.url)
        title.setValue(article.title || '')
        tags.setValue(article.tags || [])
        ED.setContents(article.body)
        _id = article._id
    })
    list.on('new', () => {
        url.setValue('https://daneshfx.com/fa/articles/')
        title.setValue('')
        tags.setValue([])
        ED.setContents('')
        _id = ''
        submit.text('ارسال')
    })
    list.on('loaded', (articles: TArticle[]) => {
        const all: string[] = []
        articles.forEach(a => (a.tags || []).forEach(t => all.push(t)))
        tags.setSuggestions(all)
    })

    grid.append(list)

    const edit = Div()
    grid.append(edit)

    const url = UrlInput('')
    edit.append(url)

    const title = TitleInput('')
    edit.append(title)

    const tags = TagsInput([])
    edit.append(tags)

    const _editor = Input('', 'textarea')
    _editor.cssClass(editorStyle)
    _editor.id = 'editor'

    let ED: any
    base.on('mounted', () => {

        ED = (window.SUNEDITOR as any).create(_editor.el, {
            defaultStyle: 'font-family: Persian; font-size: 16px;  word-spacing: 2px; line-height: 1.5;',

            height: '800px',
            strictMode: true, // Prevents unnecessary tags and styles
            pasteTagsWhitelist: 'p|ul|li|strong|em|a',
            rtl: true,
            showPathLabel: true,  // Displays the HTML tag path at the bottom
            resizingBar: true,
            maxHeight: 'calc(100vh - 380px)',
            buttonList: [
                [
                    'formatBlock', 'paragraphStyle', 'blockquote', 'bold', 'underline', 'italic', 'strike',
                    'fontColor', 'hiliteColor', 'removeFormat', 'horizontalRule', 'list', 'outdent', 'indent', 'lineHeight',
                    'table', 'link', 'image', 'video', 'dir', 'align', 'removeFormat', 'codeView'
                ]
            ],
            imageUploadUrl: '/data/images/upload-site',
        })
        ED.toggleCodeView = function (isCodeView: any, core: any) {
            // console.log('isCodeView', isCodeView, core);


            // const codeViewElement = core.context.code.view;

            // if (isCodeView && codeViewElement) {
            //     // Set LTR direction when entering code view
            //     codeViewElement.setAttribute('dir', 'ltr');
            // } else if (codeViewElement) {
            //     // Reset or remove direction when exiting code view
            //     codeViewElement.removeAttribute('dir');
            // }
        };
        // ED.onPaste = function (e: any, cleanData: any, maxCharCount: any) {
        //     const regex = /style="[^"]*"/g;
        //     const cleanedHtml = cleanData.replace(regex, '');


        //     // const cleaned = ED.util.cleanHTML(cleanData, {
        //     //     removeFormat: true,  // Removes inline styles like font-size
        //     //     removeComments: true // Removes comments
        //     // });
        //     ED.setContents(cleanedHtml);
        // };

    })
    edit.append(_editor)

    const submit = submitButton('ارسال')
    submit.enable()
    submit.cssClass(submitStyle)
    edit.append(submit)

    let _id = ''
    submit.el.addEventListener('click', async () => {
        submit.text('در حال ارسال...')
        submit.disable()
        try {
            if (_id) {
                const payload = {
                    url: url.getValue().split('/').pop() || '',
                    body: ED.getContext().element.wysiwyg.innerHTML
                        // .replace(/style="[^"]*"/g, '') // unless it's text alignment
                        .replace(/font-size:\s*[^;"]+;?/g, '')
                        .replace(/<p><\/p>/g, '')
                        .replace(/\<img\s/g, '<img style="max-width: 80%; display:block; margin:10px auto" '),
                    title: title.getValue(),
                    tags: tags.getValue(),
                    _id
                }
                await services.articles.put(payload)
                list.update(payload)
            } else {
                const payload = {
                    url: url.getValue().split('/').pop() || '',
                    body: ED.getContext().element.wysiwyg.innerHTML,
                    title: title.getValue(),
                    tags: tags.getValue(),
                }
                const saved = await services.articles.post(payload)
                list.add(saved)
                _id = saved._id
            }
            submit.text('ذخیره شد ✓')
            setTimeout(() => submit.text('تغییر و به روز رسانی'), 1800)
        } catch (e: any) {
            alert(e?.message || 'خطا در ذخیره‌سازی مقاله')
            submit.text('تغییر و به روز رسانی')
        } finally {
            submit.enable()
        }
        return base
    })

    const deleteButton = DeleteButton('حذف')
    deleteButton.cssClass({ ...submitStyle, left: '280px', backgroundColor: 'white' })
    deleteButton.on('click', async () => {
        const yes = confirm('آیا از حذف این مقاله اطمینان دارید؟')
        if (yes) {
            await services.articles.delete(_id)
            list.remove(_id)
            url.setValue('')
            title.setValue('')
            ED.setContents('')
        }
    })
    edit.append(deleteButton)

    return base
}
